import { create } from "zustand";

interface ContentItem {
  title: string;
  content: string;
}

interface SheetContent {
  header: string;
  contentArray: ContentItem[];
  button?: {
    buttonText: string;   // 按鈕文字
  };
  /** true → sheet 高度貼齊內容（到按鈕為止，不滾動）；未給沿用預設 40% 可滾動 */
  fitContent?: boolean;
}

const useHomePageSheetStore = create<{
  isSheetOpen: boolean;
  sheetContent: SheetContent | null;
  openSheet: (content: SheetContent) => void;
  closeSheet: () => void;
  setIsOpen: (isOpen: boolean) => void;
}>((set) => ({
  isSheetOpen: false,
  sheetContent: null,

  // 開啟 sheet 並設定內容
  openSheet: (content) => set({ isSheetOpen: true, sheetContent: content }),

  // 關閉 sheet
  // 只切換 isSheetOpen，刻意保留 sheetContent：sheet 內容是用 `{sheetContent && ...}`
  // 條件渲染，若在這裡同步把它清成 null，內容會在 medium 關閉動畫進行中瞬間卸載、
  // frame 高度塌陷，造成關閉動畫卡頓。保留內容讓 frame 帶著內容平滑滑出
  //（與 X 關閉鈕的 setIsOpen(false) 行為一致），下次 openSheet 會覆寫內容。
  closeSheet: () => set({ isSheetOpen: false }),

  // 直接設定 isSheetOpen 狀態
  setIsOpen: (isOpen) => set({ isSheetOpen: isOpen }),
}));

export default useHomePageSheetStore;
